import { observer } from 'mobx-react';
import SegmentStore from '../../../../../../SegmentStore';
import Loader from '../../../../../Loader';
import SegmentContent from './SegmentContent';

interface Props {
  store: SegmentStore;
}

function ContentStates({ store }: Props) {
  switch (store.state.kind) {
    case 'ready':
    case 'processing-request':
    case 'completing':
    case 'reporting-results':
    case 'schedule-session':
      return <SegmentContent store={store} segmentResource={store.state.segmentResource} />;
    case 'quiz-failed':
    case 'completing-and-advancing':
    case 'submitting-and-advancing':
    case 'previous-advancing':
    case 'advancing':
    case 'advancing-to':
    case 'error':
    case 'waiting':
    case 'loading':
    case 'loaded':
      return (
        <div className="flex min-h-64 flex-grow">
          <Loader color="black" type="spin" />
        </div>
      );
  }
}

export default observer(ContentStates);
